import { fetchCustomFields} from '@/api/customfield'

export const DynamicField = {
  data () {
    return {
      custom_fields : [],   //in this we are storing custom value (dynamic field value)
      custom_fields_required : [] //to store required custom value
    }
  },
  methods:{

    async fetch_customfields_list (model) {
      //   this.$vs.loading()
      
      const tempModel = model
      try {
                    
        if (model === 'CRM' || model == 'Leads') {
          model = 'Crm'
        }
                    
        const customerId = this.$store.getters.customerId
    
        const { data } = await fetchCustomFields(model, customerId)
        //here model is module name Like Leads, Client, Staff(etc) and customer is the platform_customer_id
        // 
        this.custom_fields = data.data.custom_fields
    
        //  value here
        //only to fetch custom field required
        this.custom_fields_required = this.custom_fields.filter(function (el) {
          return el.is_required === true
        })
        //to assigning entity model [App/Leads,App/CLients]
        this.entityModel = data.data.entitymodels
        // 
        //for assigning customdynamic fields in form object
        for (let i = 0; i < this.custom_fields_required.length; i++) {
          if (this.custom_fields_required[i].inputtype === 'checkbox' || this.custom_fields_required[i].inputtype === 'multiselect') {
            this.$set(this.dynamicFormObject, this.custom_fields_required[i].field, [])
          } else {
            this.dynamicFormObject[this.custom_fields_required[i].field] = ''
          }
        }
        return true
      } catch (err) {
        
        return false
        // this.$vs.loading.close()
      }
    
    }

  }
}